<template lang="">
  <div>
    <section id="subVisual" class="subVis2">
      <div>
        <h2>QUEST</h2>
        <p>
          축적된 노하우와 기술력으로 최적의 솔루션과 서비스를 제공하겠습니다.
        </p>
      </div>
    </section>
    <main id="cont">
      <div id="overview" class="subCon inner_box">
        <section class="platform1">
          <h3 class="con_tit" id="about">About SharePlex</h3>

          <div class="img">
            <v-img
              src="@/assets/img/quest/shareplex/about.png"
              alt=""
              style="
                width: 60%;
                height: 60%;
                border-radius: 8px;
                box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
                  0 6px 20px 0 rgba(0, 0, 0, 0.19);
              "
            />
          </div>

          <div class="con">
            <p style="font-size: 16px">
              다양한 비즈니스 요구 증대에 따라 운영시스템의 환경 및 성능,
              <br />구조에 영향을 주지 않고 운영DB의 부하를 최소화하며
              <br />성능을 극대화할 수 있도록 DB를 추출/적재하는 <br />DB
              복제솔루션인 CDC(Change Data Capture) <br />솔루션이 필요하게
              되었습니다.
            </p>
            <p style="font-size: 16px">
              SharePlex는 원본 Database의 성능과 가용성을 향상시키는 동시에
              <br />복사본 Database를 활용한 <br />부하 분산 업무 및 통합 업무에
              활용할 수 있도록 해주는 <br />Oracle 로그기반의 데이터베이스 복제
              전문 솔루션 입니다.
            </p>
          </div>

          <div class="H60"></div>

          <h3 class="con_tit" id="architecture">SharePlex 특/장점</h3>

          <div class="cocon">
            <v-img
              src="@/assets/img/quest/shareplex/architecture.png"
              style="margin: 0 auto; max-width: 80%; align-items: center"
            />

            <ol class="clearfix">
              <li>
                <span class="num">01</span>
                <dl>
                  <dt>로그기반 실시간 데이터 복제</dt>
                  <dd>
                    Oracle Redo/Archive Log Direct Access
                    <br />DB부하 최소, 고성능 추출 <br />이기종 HW 및 OS 구성
                    가능
                  </dd>
                </dl>
              </li>
              <li>
                <span class="num">02</span>
                <dl>
                  <dt>데이터 무결성/정합성 보장</dt>
                  <dd>
                    Before/After image check를 통한 데이터 자동 정검
                    <br />실시간 Data 정합성 검증 <br />모든 Out Of Sync 이력 및
                    SQL문을 log파일에 기록
                  </dd>
                </dl>
              </li>
              <li>
                <span class="num">03</span>
                <dl>
                  <dt>
                    다양한 복제 단위<br />
                    DML/DDL 복제 (Oracle To Oracle)
                  </dt>
                  <dd>
                    <br />Schema, Table, Colum, Row 단위 복제 지원
                    <br />DDL복제의 경우 Parameter 옵션으로 다양한 범위조정
                  </dd>
                </dl>
              </li>
            </ol>

            <div style="height: 20px"></div>
            <ol class="clearfix">
              <li>
                <span class="num">04</span>
                <dl>
                  <dt>Change History / MetaData 관리</dt>
                  <dd>
                    변경이력 추적 및 감사 목적의 데이터 수집
                    <br />Source system에서 전달된 데이터의 MetaData 제공
                    <br />(user, time, operation type, scn, rowid etc..)
                  </dd>
                </dl>
              </li>
              <li>
                <span class="num">05</span>
                <dl>
                  <dt>복제에 대한 latency 최소화</dt>
                  <dd>
                    Commit 전 Data 복제 처리
                    <br />유사 데이터 배열 처리 (Array Processing) <br />Queue
                    다중화 및 분산 처리 가능
                  </dd>
                </dl>
              </li>

              <li>
                <span class="num">06</span>
                <dl>
                  <dt>Auto Recovery</dt>
                  <dd>
                    단일 Log파일로 통합 모니터링 관리 용이
                    <br />네트워크 장애 시 지속적인 Data Capture로 Data 연속셩
                    유지 <br />DB장애 시 Check Point 기록으로 Data 연속성 유지
                  </dd>
                </dl>
              </li>
            </ol>
          </div>

          <div class="H60"></div>

          <h3 class="con_tit" id="cloud">이기종 DB 및 Cloud 지원</h3>

          <v-img
            src="@/assets/img/quest/shareplex/cloud.png"
            style="margin: 0 auto; max-width: 80%; align-items: center"
          />
        </section>
      </div>
    </main>
  </div>
</template>
<script>
export default {};
</script>
<style lang=""></style>
